export enum ReceptionCommentSortItemKinds {
  UpdateDateTime = 0,
  CreateDateTime = 1,
}
